var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._b({class:_setup.classes},'div',_vm.$attrs,false),_vm._l((_vm.$attrs.ui),function(i,index){return _c(_vm.$attrs.is,_vm._b({key:index,tag:"component",class:[{ 'flex-1': !i.noFlex }, i.class]},'component',i,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }